import React from "react";
import { ModalWrapper } from "../../../../components/ModalWrapper";
import CommonButtons from "../../../../components/CommonButtons";

interface DeleteCategoryModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  categoryName: string;
}

const DeleteCategoryModal: React.FC<DeleteCategoryModalProps> = ({ open, onClose, onConfirm, categoryName }) => {
  if (!open) return null; // don’t render when closed

  return (
    <ModalWrapper title="Delete Confirmation" onClose={onClose} width="max-w-xl">
      <div className="addcategory-edit">
        {categoryName && ( <p className="font-semibold" id="category-name">Category name: {categoryName}</p> )}
        <p className="mt-6">Are you sure you want to delete this category?</p>
        <p className="delete-category-note mt-2 text-sm text-gray-600">
          <strong>Note:</strong> When you delete the category, the added products are also deleted.
        </p>

        <div className="flex justify-end gap-6 mt-6" id="cancel-button">
          <CommonButtons className="w-36 h-10" label="Cancel" variant="outlineDanger" onClick={onClose} />
          <CommonButtons className="w-36 h-10" label="Confirm" onClick={onConfirm} />
        </div>
      </div>
    </ModalWrapper>
  );
};

export default DeleteCategoryModal;
